export const transformUsers = ({ data }) =>
  data.map((dado, index) => {
    return {
      ...dado,
      id: index,
      imobiliaria: 'TDA Seguros',
    };
  });
